import { render, staticRenderFns } from "./advocacy-alert-filter-app.vue?vue&type=template&id=af5b754a&"
import script from "./advocacy-alert-filter-app.vue?vue&type=script&lang=js&"
export * from "./advocacy-alert-filter-app.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\Kentico\\Launchpad.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('af5b754a', component.options)
    } else {
      api.reload('af5b754a', component.options)
    }
    module.hot.accept("./advocacy-alert-filter-app.vue?vue&type=template&id=af5b754a&", function () {
      api.rerender('af5b754a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/custom/vue/containers/advocacy-alert-filter-app.vue"
export default component.exports